import React, {createContext, useContext, useReducer} from 'react';

export const StateContext = createContext(null);

export const useStateValue = () => useContext(StateContext);

export const StateProvider = ({reducer, initialState, children}) => {
    // console.log(`*** StateProvider - initialState: ${JSON.stringify(initialState, null, 2)}`);

    return (
        <StateContext.Provider value={useReducer(reducer, initialState)} >
            {children}
        </StateContext.Provider>
    )
};


